<script setup lang="ts">
import { useTranslation } from "@Resources/js/composables";
import type { Domain } from "@Modules/urls/Data/Models/DomainModel";
import { toShortDateTime } from "@Helpers/support";

//
// Setup
const { __ } = useTranslation();

//
// Props
interface Props {
  domain: Domain;
}

defineProps<Props>();
</script>

<template>
  <div class="domain-info-header">
    <h5 class="domain-info-header__name text-muted">
      {{ domain.domain }}
    </h5>
    <div class="domain-info-header__dates">
      <span class="domain-info-header__date">
        {{ __("organization_domains_settings.edit_domain_popover.created_label") }}
        {{ toShortDateTime(domain.created_at) }}
      </span>
      <span class="domain-info-header__date">
        {{ __("organization_domains_settings.edit_domain_popover.updated_label") }}
        {{ toShortDateTime(domain.updated_at) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.domain-info-header {
  display: flex;
  flex-flow: column;
  gap: spacing.$xxxs;

  &__name {
    font-size: typography.$h5-font-size;
    font-weight: typography.$font-weight-semi-bold;
    line-height: typography.$h5-line-height;
    margin: 0;
  }

  &__dates {
    display: flex;
    gap: spacing.$xs;
  }

  &__date {
    font-size: 0.75rem;
    color: color.$text-secondary;
  }
}
</style>
